import fp from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import { ClassNames } from '@emotion/core'
import { NavLink } from 'react-router-dom'
import { Text, Margin, MenuWrapper } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'
import { observer } from 'mobx-react'

import * as styles from './styles'

const MenuComponent = ({ items, appConfig }) => (
  <MenuWrapper as="menu" css={styles.menu} isOpen={appConfig.isMenuOpen}>
    {fp.map(
      ({ title, icon, path }) => (
        <Margin as="li" key={`${title}${icon}${path}`} tb={2}>
          <ClassNames>
            {({ css }) => (
              <NavLink
                exact
                to={path}
                css={styles.link}
                activeClassName={css(styles.activeLink)}
                onClick={() => {
                  appConfig.toggleMenu(false)
                }}
              >
                <span />
                <div css={styles.actionItem}>
                  <CustomIcon icon={icon} style={styles.actionIcon} />
                  <Text size={11}>{title}</Text>
                </div>
              </NavLink>
            )}
          </ClassNames>
        </Margin>
      ),
      items
    )}
  </MenuWrapper>
)

MenuComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  className: PropTypes.string,
  appConfig: PropTypes.shape(),
}

export default observer(MenuComponent)
